import { render } from "./tag.md?vue&type=template&id=096f77d2"
import script from "./tag.md?vue&type=script&lang=js"
export * from "./tag.md?vue&type=script&lang=js"
script.render = render

export default script